import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpFocus
     * @memberof app
     *
     * @restrict A
     *
     * @description
     * An attribute with an id that focuses the element with the matching id when the `pkpFocus()` method is executed.
     *
     * @example
     * <button ng-click="pkpFocus('thisIsAnId')"></button>
     * <input pkp-focus id="thisIsAnId">
     * // Whenever `pkpFocus()` is called, the element with the matching id will gain focus.
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpFocus', pkpFocus);

    function pkpFocus($timeout) {
        return {
            restrict: 'A',
            scope: false,
            link: linkFn
        };

        function linkFn(scope, elem) {
            scope.pkpFocus = pkpFocus;

            function pkpFocus(inputFieldId) {
                if (elem[0].id !== inputFieldId) {
                    return;
                }

                $timeout(function () {
                    elem[0].focus();
                });
            }
        }
    }
})();
